import Toast from "../../_util/Toast";
import readableSize from "readable-size";


export var inputFiles = [];
export var exportFiles = new DataTransfer();
export function updateInfoFromFileinput (this: HTMLInputElement, event: Event) {
    var filesStr = "";
    if (this.files.length > 8) {
        Toast.error('Capacidade máxima de 8 imagens não pode ser excedida.')
    } else {
        document.querySelector<HTMLSpanElement>('#documentosQuantidade')
            .innerHTML = (exportFiles.files.length+1).toString();

        const tamanho = Object.values(exportFiles.files)
            .reduce((a: number, b: File) => a + b.size, .0);
        document.querySelector<HTMLSpanElement>('#documentosTamanho')
            .innerHTML = readableSize(tamanho);

        for (let i = 0; i < this.files.length; i++) {
            exportFiles.items.add(this.files[i])
            inputFiles.push(this.files[i]);
            filesStr += "<li class='list-group-item d-flex justify-content-between' > <text style='max-width: 200px;overflow: hidden; white-space: nowrap; text-overflow: ellipsis;'>"+ this.files[i].name + "</text><button class='remove-btn btn btn-sesc-blue'>Remover</button>" + "</li>";
        }
        this.files = exportFiles.files;

        document.getElementById("dp-files").innerHTML += filesStr;
        var removeButtons = document.querySelectorAll('.remove-btn');
        removeButtons.forEach(function(button) {
            button.addEventListener('click', function() {
                removeLi(button);
            });
        });
    }
}
export function removeLi(e) {
    var li = e.parentNode;
    var filename = li.textContent.split("Remover")[0].trim();
    inputFiles = inputFiles.filter(function(file) {
        return file.name !== filename;
    });
    li.parentNode.removeChild(li);
}


